
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[dir1]/[dir2]/feedback",
      function () {
        return require("private-next-pages/[dir1]/[dir2]/feedback.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[dir1]/[dir2]/feedback"])
      });
    }
  